<script setup lang="ts">
import { searchFilterOpened } from "@/analytics/events/search";
import { trackEvent } from "@/analytics/track";
import BaseButton from "@/components/ui/BaseButton/BaseButton.vue";
import BaseTooltip from "@/components/ui/BaseTooltip/BaseTooltip.vue";
import DropdownMenu from "@/components/ui/DropdownMenu/DropdownMenu.vue";
import FlashIcon from "@/components/ui/FlashIcon.vue";
import InfoMarker from "@/components/ui/InfoMarker/InfoMarker.vue";
import { fetchSignals } from "@/store/search/signalSync";
import { useSignalStore } from "@/store/search/signals";

import SignalsList from "../SignalsList.vue";
import SignalsItemTooltip from "../tooltips/SignalsItemTooltip.vue";

const signalStore = useSignalStore();

function open() {
  trackEvent(searchFilterOpened("signals"));
  void fetchSignals();
}
</script>

<template>
  <DropdownMenu width="lg" stay-open-on-content-click @open="open">
    <template #trigger="{ isOpen }">
      <BaseTooltip position="bottom" class="flash-icons">
        <BaseButton
          variant="ghost"
          color="grey"
          class="flash-icons-button"
          data-dropdown-trigger
          :aria-label="$t('label.search.filterButton', { value: $t('signals.title') })"
          :aria-expanded="isOpen"
          aria-haspopup="listbox"
          :activated="isOpen"
        >
          <FlashIcon link-state="default" />
          <InfoMarker v-if="signalStore.selectedItems.length" :top="4" :right="4" />
        </BaseButton>
        <template #content>
          <SignalsItemTooltip :items="signalStore.selectedItems" />
        </template>
      </BaseTooltip>
    </template>
    <SignalsList source="search" :header="$t('signals.title')" />
  </DropdownMenu>
</template>

<style lang="scss" scoped>
.flash-icons {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 40px;
  height: 40px;
  border-radius: 6px;
  cursor: pointer;
}

.flash-icons-button.flash-icons-button {
  display: block;
  line-height: 12px; // Keep the icon centered vertically, with or without the status dot
}
</style>
